import { bool, func } from 'prop-types';
import { FormStack, Stack } from '../../shared/layouts';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import Select from '../../shared/Select';
import InfoModal from '../../shared/InfoModal';
import LonelyPlaceholder from '../../shared/LonelyPlaceholder';
import i18n from "../../../i18n";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

export const getSmokeBehaviourOptions = () => [
  { label: i18n.t('Roker'), value: true },
  { label: i18n.t('Niet-roker'), value: false },
];

const HealthSection = ({
  is_smoker,
  handleChange,
  errors,
  partner,
  readOnly,
  FormFiller,
}) => {
  const { t } = useTranslation();
  const { ShieldIcon } = useIconLibrary();
  const smokeBehaviourOptions = getSmokeBehaviourOptions();

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={
            <>
              {t('Gezondheid') + (partner ? ' ' + t('partner') : '')}
              <InfoModal title={t("Gezondheid")}>
                {t('Deze informatie wordt gevraagd om betere berekeningen te kunnen maken. Of je rookt of niet (meer) rookt, heeft bijvoorbeeld invloed op de hoogte van de premie voor je overlijdensrisicoverzekering (ORV). De meeste verzekeringsmaatschappijen hanteren twee jaar na je laatste sigaret als moment waarop je definitief bent gestopt. Je komt dan mogelijk in aanmerking voor een lagere premie.')}
              </InfoModal>
            </>
          }
          icon={<ShieldIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          <Select
            label={t("Rookgedrag")}
            name="is_smoker"
            onChange={handleChange}
            options={smokeBehaviourOptions}
            value={typeof is_smoker === 'boolean' ? is_smoker : ''}
            errors={errors.is_smoker}
            emptyOption
            readOnly={readOnly}
          />
          <FormFiller />
          <LonelyPlaceholder />
        </FormStack>
      </Stack>
    </Card>
  );
}

HealthSection.propTypes = {
  isSmoker: bool,
  partner: bool,
  handleChange: func,
};

export default HealthSection;
